// extracted by mini-css-extract-plugin
export var black = "_4c-6";
export var brand = "_4c-1";
export var ddefault = "_4c-0";
export var error = "_4c-3";
export var gray = "_4c-2";
export var highContrast = "_4c-8";
export var outline = "_4c-7";
export var success = "_4c-5";
export var warning = "_4c-4";